import { isAdmin } from 'services/adminCheck';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'components/elements/molecules/Toast/Toast';
import { Icon, ICONS } from 'components/Icons';
import ToolTip from 'components/elements/atoms/ToolTip/ToolTip';

export default function UserWithDetailsPopoverContent({
  username,
  user,
  course,
  selectShowCourseDashboard,
  history,
  setShowUserLevelModal,
  setShowUserExtensionActionHistoryModal,
  breadCrumb,
  setPortfolioBreadCrumb,
}) {
  const onViewArticles = (user) => {
    if (isAdmin) {
      history.push(`/allArticles?user=${user.username}`);
    } else if (course) {
      console.log('selectShowCourseDashboard');
      selectShowCourseDashboard('Articles', {
        filterUsername: username,
        filterFromDate: course.startDate || course.createdAt,
        filterToDate: course.endDate || new Date(),
      });
    }
  };

  const onViewLogSources = (user) => {
    history.push(`/logSourceBreakdown?user=${user.username}`);
  };

  const goToStudentActivityTab = (username) => {
    if (isAdmin) {
      window.open(
        `https://www.averpoint.com/portfolio/${username}/activity`,
        '_blank',
      );
    } else {
      if (breadCrumb) {
        setPortfolioBreadCrumb([
          ...breadCrumb,
          { label: `${username} weekly activity` },
        ]);
      }

      history.push(`/portfolio/${username}/activity`);
    }
  };

  if (!user) {
    return <div>User details not found</div>;
  }

  const level =
    user.profile.roles?.find((i) => i.type === 'community')?.level || '-';

  return (
    <div className="mt-2">
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Username</div>
        <div className="col-xs-9">
          <div className="d-flex align-items-center">{user.username}</div>
        </div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Name</div>
        <div className="col-xs-9">{user.fullName}</div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Email</div>
        <div className="col-xs-9 d-flex align-items-center">
          <span
            className="flex-fill"
            style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {user.email}
          </span>
          <ToolTip
            toolTipText="Copy"
            className="d-inline-flex align-items-center flex-shrink-0"
          >
            <CopyToClipboard
              text={user.email}
              onCopy={() => {
                toast('Email copied to clipboard');
              }}
            >
              <button
                className="btn-sm btn-link p-0 ml-2 d-inline-flex align-items-center flex-shrink-0"
                type="button"
              >
                <Icon icon={ICONS.COPY} />
              </button>
            </CopyToClipboard>
          </ToolTip>
        </div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Roles</div>
        <div className="col-xs-9">
          {user.profile.roles?.map((role) => role.type).join(', ') || '-'}
        </div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Level</div>
        <div className="col-xs-9">{level}</div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Schools</div>
        <div className="col-xs-9">{user.schools?.join(', ') || '-'}</div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Courses</div>
        <div className="col-xs-9">{user.courses?.join(', ') || '-'}</div>
      </div>
      <div className="row pb-2">
        <div className="col-xs-3 font-weight-600">Reports</div>
        <div className="col-xs-9">
          <div className="row pb-2">
            <div className="col-xs-9 user-details-activity-title">Activity</div>
            <div
              className="col-xs-3 av-blue text-underline cursor-pointer"
              onClick={() => goToStudentActivityTab(user.username)}
            >
              View
            </div>
          </div>
          {isAdmin && (
            <div className="row pb-2">
              <div className="col-xs-9 user-details-activity-title">
                Articles
              </div>
              <div
                className="col-xs-3 av-blue text-underline cursor-pointer"
                onClick={() => onViewArticles(user)}
              >
                View
              </div>
            </div>
          )}
          {isAdmin && (
            <div className="row pb-2">
              <div className="col-xs-9 user-details-activity-title">
                Log sources
              </div>
              <div
                className="col-xs-3 av-blue text-underline cursor-pointer"
                onClick={() => onViewLogSources(user)}
              >
                View
              </div>
            </div>
          )}
          <div className="row pb-2">
            <div className="col-xs-9 user-details-activity-title">
              Level history
            </div>
            <div
              className="col-xs-3 av-blue text-underline cursor-pointer"
              onClick={() => {
                setShowUserLevelModal(true);
                document.body.click();
              }}
            >
              View
            </div>
          </div>
          <div className="row pb-2">
            <div className="col-xs-9 user-details-activity-title">
              Extension Actions
            </div>
            <div
              className="col-xs-3 av-blue text-underline cursor-pointer"
              onClick={() => {
                setShowUserExtensionActionHistoryModal(true);
                document.body.click();
              }}
            >
              View
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
